import styled from "styled-components";
import {
  ArrowDropdownDown,
  Button,
  Site,
  borderRadius,
  color,
  elevation,
  layer,
  palette,
  spacing,
  typography,
} from "@conserveit/blocks";
import { AVATARS, TYPOGRAPHY } from "../../components/AppChrome/App.constants";
import SearchComponent from "./components/Search";

interface Props {
  isOpen: any;
}

export const LoadingContainer = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  justify-content: space-around;
  align-items: center;
  height: calc(100% - 45px);
`;

export const MenuWrapper = styled.div`
  position: relative;
  margin-left: ${spacing.extraLoose};
`;

export const SearchWrapper = styled.div`
  display: flex;
  padding: ${spacing.snug} ${spacing.default};
  border-bottom: 1px solid ${color.theme.divider.solid};
  background: ${palette.neutral2};
`;

export const Search = styled(SearchComponent)`
  flex-basis: calc(100% / 1.5);

  input {
    height: 32px;
  }
`;

export const MenuContainer = styled.div<Props>`
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};
  position: absolute;
  left: 0;
  top: 0;
  width: 760px;
  min-height: 400px;
  border-radius: ${borderRadius.default};
  border: 1px solid ${color.theme.divider.solid};
  box-shadow: ${elevation.contentNavigation};
  z-index: ${layer.contextNavigation};
  background: ${color.pureWhite};
`;

export const ColumnContainer = styled.div`
  display: flex;
  height: 344px;
  border-bottom: 1px solid ${color.theme.divider.solid};

  .Column {
    display: inline-flex;
    flex-direction: column;
    width: ${100 / 3}%;

    border-right: solid 1px ${color.theme.divider.solid};
    overflow: hidden;

    &:last-child {
      border-right: none;
    }
  }

  .MenuSection-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: ${spacing.default} ${spacing.default} ${spacing.snug};
  }

  h2 {
    margin: 0;
    font-size: 12px;
    font-weight: ${TYPOGRAPHY.WEIGHTS.BOLD};
    text-transform: uppercase;
    color: ${palette.neutral8};
  }

  .MenuSection-list {
    height: 100%;
    width: 100%;
    padding: 0;
    overflow-y: scroll;
  }

  .MenuSection-inner {
    height: 100%;
  }
`;

export const Triangle = styled(ArrowDropdownDown)`
  display: inline-block;
  position: relative;
  margin-left: ${spacing.tight};
  fill: ${color.theme.white};
  width: 10px;
`;

export const GlobalSite = styled.button`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  height: ${AVATARS.BASE};
  padding: 0;
  border: none;
  outline: 0;
  background: transparent;
`;

export const TitleSite = styled.div`
  display: inline-block;
  position: relative;
  background: none;
  ${typography.displaySmall}

  .ActiveSite-site {
    display: block;
    color: ${color.theme.white};
  }
`;

export const IconWrapper = styled.div`
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
  margin-right: ${spacing.tight};
  height: ${AVATARS.BASE};
  width: ${AVATARS.BASE};
  border-radius: 50%;
  background: rgba(${color.pureWhite}, 0.1);
`;

export const Building = styled(Site)`
  display: inline-block;
  fill: ${color.theme.white};
  background: transparent;
`;
export const Clear = styled(Button)`
  text-transform: uppercase;
  font-size: 12px;
  color: ${palette.neutral8};
`;
